import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationChannelSettingRequestModel } from '../models/notification-channel-setting-request.model';
import { NotificationSettingsViewModel } from '../models/notification-settings-view.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationSettingsService {
  constructor(private http: HttpClient) {}

  getByRole(roleId: string): Observable<NotificationSettingsViewModel> {
    return this.http.get<NotificationSettingsViewModel>(this.getRoleUrl(roleId));
  }

  updateByRole(
    roleId: string,
    settings: NotificationChannelSettingRequestModel[]
  ): Observable<void> {
    return this.http.put<void>(this.getRoleUrl(roleId), settings);
  }

  private getRoleUrl(roleId: string): string {
    return environment.apis.default.url + '/api/app/notification-settings/roles/' + roleId;
  }
}
